import React from "react";
import Header from "../components/Header";
import RecoverPasswordSection from "../sections/authentication/RecoverPasswordSection";

function RecoverPasswordPage() {
  return (
    <div className={ClassName.container}>
      <Header />
      <RecoverPasswordSection />
    </div>
  );
}

export default RecoverPasswordPage;

const ClassName = {
  container: "flex flex-col text-black relative font-main",
};
